
<div class="card-profile-actions">
  <div class="actions">
    <div class="left">
      <icon-button
        tooltip="Close card"
        icon="close"
        @click="close"
      />

      <icon-button
        v-if="page"
        tooltip="Minify back to panel"
        class="medium-up"
        icon="exit_to_app"
        @click="minify"
      />

      <icon-button
        v-else
        tooltip="View card in fullscreen mode"
        class="medium-up"
        icon="fullscreen"
        @click="fullscreen"
      />
    </div>

    <div class="right">
      <verified-icon
        v-if="card.cardId"
        v-tooltip="{ content: 'Verified Profile', delay: { show: 1500, hide: 100 }, placement: 'bottom' }"
      />

      <icon-button
        v-if="cardId"
        :tooltip="inCollection ? 'Remove from Collection' : 'Add to Collection'"
        :icon="inCollection ? 'delete_outline' : 'bookmark_add'"
        @click="handleCollection"
      />

      <icon-button
        v-else
        tooltip="Remove from Collection"
        icon="delete_outline"
        @click="removeFromCollection"
      />

      <dropdown
        align="right"
        :active="menuOpen"
        @close="menuOpen = false"
      >
        <div>
          <icon-button
            icon="more_vert"
            :loading="refreshingStats"
            @click="menuOpen = !menuOpen"
          />
        </div>

        <template #menu>
          <dropdown-menu
            :options="actionOptions"
            @select="handleSelect"
          />
        </template>
      </dropdown>
    </div>
  </div>

  <portal to="cardfeedback">
    <feedback-modal
      title="Tell us what's wrong"
      :open="showFeedbackModal"
      :card="card"
      @close="showFeedbackModal = false"
    />
  </portal>
</div>
